export default __webpack_public_path__ + "static/media/walvis1Klein.a165fdd4.jpg";